import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-no-records-message',
  templateUrl: './no-records-message.component.html',
  styleUrls: ['./no-records-message.component.scss']
})
export class NoRecordsMessageComponent implements OnInit {
  // @Input() ListVariable: any[];
  showMessage = false;
  constructor() { 
   
  }

  @Input()
  set ListVariable(ListVariable: any[]) {
    this.showMessage = (!ListVariable || ListVariable.length == 0);
  }

  ngOnInit() {
  }

}
